"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: visibility 0.2s, opacity 0.1s ease-in;\n  font-family: ", ";\n  position: fixed;\n  left: 0;\n  display: block;\n  background-color: ", "F5;\n  color: ", ";\n  box-shadow: 0 2px 6px 0 ", "1F;\n  border-radius: 4px;\n  padding: 12px;\n  z-index: 9999;\n  visibility: hidden;\n  opacity: 0;\n\n  &.hidden {\n    display: none;\n  }\n"], ["\n  transition: visibility 0.2s, opacity 0.1s ease-in;\n  font-family: ", ";\n  position: fixed;\n  left: 0;\n  display: block;\n  background-color: ", "F5;\n  color: ", ";\n  box-shadow: 0 2px 6px 0 ", "1F;\n  border-radius: 4px;\n  padding: 12px;\n  z-index: 9999;\n  visibility: hidden;\n  opacity: 0;\n\n  &.hidden {\n    display: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map